import { render } from "./PaneParadigm.vue?vue&type=template&id=25b1fa8c&scoped=true&ts=true"
import script from "./PaneParadigm.vue?vue&type=script&lang=ts"
export * from "./PaneParadigm.vue?vue&type=script&lang=ts"

import "./PaneParadigm.vue?vue&type=style&index=0&id=25b1fa8c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b1fa8c"]])

export default __exports__